export const useImageOptimizer = (url) => {
  if (!url) {
    return url
  }
  return url + '?auto=format,compress'
}
